<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <money-box-new-form @codeChange="codeChange">
          </money-box-new-form>
        </div>
        <div class="col-md-4">
          <card style="width: max-content;">
            <span style="margin-bottom: 10px;display: inline-block;">QR Kod Alanı</span>
            <qrcode-vue v-if="code.length" :value="code" :size="150" level="H" />
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import QrcodeVue from 'qrcode.vue'
  import MoneyBoxNewForm from './MoneyBox/MoneyBoxNewForm.vue'

  export default {
    components: {
      MoneyBoxNewForm,
      QrcodeVue
    },
    data(){
      return {
        code: ''
      }
    },
    methods:{
      codeChange(code){
        const self = this;
        console.log("asdasd")
        self.code = code
      }
    }
  }

</script>
<style>

</style>
